import { isNil } from 'lodash';
export const getFilterValueFormat = (filter) => {
    const formatters = {
        EXIST: (_) => 'exists',
        IS: (value) => value,
        LOOKUP: (value) => `Lookup: ${value?.name}`,
        IS_ONE_OF: (value) => value.join(', '),
        IS_BETWEEN: (value) => `${!isNil(value.gte) ? value.gte : '-∞'} to ${!isNil(value.lt) ? value.lt : '+∞'}`,
        LESS_THAN: (value) => `-∞ to ${!isNil(value.lt) ? value.lt : '+∞'}`,
        GREATER_THAN: (value) => `${!isNil(value.gte) ? value.gte : '-∞'} to +∞`,
        LUCENE: (value) => `query: ${value}`,
    };
    const formatter = formatters[filter.type];
    if (!formatter) {
        return String(filter.value ?? '');
    }
    return String(formatter(filter?.value));
};
//# sourceMappingURL=utils.js.map